import { ThemeEvents } from '@theme/events';
import { shippingOriginState } from './pristine-shipping-origin-state.js';

class PristineShippingOrigin extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.scope = this.closest('.shopify-section');
    const options = { signal: this.controller.signal };
    this.scope?.addEventListener(ThemeEvents.variantUpdate, this.updateVariant, options);
    this.scope?.addEventListener(ThemeEvents.variantSelected, this.pendingVariant, options);
    this.scope?.addEventListener(ThemeEvents.quantitySelectorUpdate, this.updateQuantity, options);
    this.scope?.addEventListener('change', this.updateQuantity, options);
    this.refresh();
    this.expiryTimer = setInterval(() => this.refresh(), 60000);
  }

  disconnectedCallback() {
    this.controller?.abort();
    clearInterval(this.expiryTimer);
  }

  pendingVariant = () => {
    const status = this.querySelector('[data-origin-status]');
    if (status) status.textContent = '';
  };

  updateVariant = (event) => {
    if (String(event.detail.data.productId) !== this.dataset.productId && !event.detail.data.newProduct) return;
    const replacement = event.detail.data.html.querySelector('pristine-shipping-origin');
    if (!replacement) return;
    this.dataset.productId = replacement.dataset.productId;
    this.dataset.orderType = replacement.dataset.orderType;
    this.dataset.country = replacement.dataset.country;
    this.dataset.variantId = replacement.dataset.variantId;
    this.innerHTML = replacement.innerHTML;
    this.refresh();
  };

  updateQuantity = () => this.refresh();

  refresh() {
    const dataElement = this.querySelector('[data-origin-data]');
    const status = this.querySelector('[data-origin-status]');
    if (!dataElement || !status) return;
    try {
      const data = JSON.parse(dataElement.textContent);
      const quantity = this.scope?.querySelector('input[name="quantity"]')?.value || 1;
      const state = shippingOriginState({ ...data, orderType: this.dataset.orderType, country: this.dataset.country, quantity });
      status.textContent = data.messages[state] || data.messages.unknown;
      this.dataset.originState = state;
    } catch {
      this.dataset.originState = 'unknown';
    }
  }
}

if (!customElements.get('pristine-shipping-origin')) customElements.define('pristine-shipping-origin', PristineShippingOrigin);
